import {types} from './types';

const setGetViewBonusesAction = (payload) => {
    return {
        type: types.SET_VIEW_BONUSES,
        payload,
      }
}

const setGetListBonusesAction = (payload) => {
  return {
    type: types.SET_LIST,
    payload
  }
}

export {
  setGetViewBonusesAction,
  setGetListBonusesAction
}
